"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* action type that can be trigged across reducers */
var GlobalActionType;
(function (GlobalActionType) {
    GlobalActionType["CLEAR_SAVE"] = "global_CLEAR_SAVE";
})(GlobalActionType = exports.GlobalActionType || (exports.GlobalActionType = {}));
